import React from 'react'
import PaymentSummary from './PaymentSummary/PaymentSummary'
import ProductItem from './ProductItem/ProductItem'


const InventorySaleCart = ({bag,register}) => {
    
    const calculeTotal = (bag) =>{
        let total = 0
        bag.map(product => {
            total = total + (product.quantity * product.unit_price)
            return product
        })
        return total
    }
    
    return (
        <div className='shoping-bag-container'>

            <div className='list-products-bag scroll-menu'>
                {bag.map(item => (
                    <ProductItem item={item} />
                ))}
            </div>
            <PaymentSummary
            register ={register}
            total ={calculeTotal(bag)}
                  />
        </div>
    )
}

export default InventorySaleCart